<template>
  <div class="cb-hp__wrapper">
    <div ref="parent" class="cb-header cb-transition__slide" id="cb-header">
      <component :is="headerType" :edit-mode="editMode" v-cb-slide="{ isnew : isNewHeader , ref: $refs.parent }">
      </component>
    </div>
    <div class="cb-body" id="cb-body" v-if="hp_partially_loaded" role="main">
      <transition :name = "current_notification && current_notification.isDismissible ? 'fade' : 'scale-down-y'">
        <cb-modal :icon="current_notification.type" :show-icon="current_notification.showIcon" :text="current_notification.message" v-if="showNotification" :is-dismissible="current_notification.isDismissible" @clearModalDialog="showNotification = false">
        </cb-modal>
      </transition>
      <cb-loader v-if="showLoader"></cb-loader>
      <router-view v-cb-animate='canAnimate'></router-view>
    </div>
  </div>
</template>
<style src="@/assets/styles/checkout.styl" lang="stylus"></style>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import Type1 from "@/components/collections/headers/Type1"
import Type2 from "@/components/collections/headers/Type2"
import Type3 from "@/components/collections/headers/Type3"
import ThankYouHeader from "@/components/collections/headers/ThankYouHeader"
import ModalBox from "@/components/collections/elements/ModalBox"
import CBNotification from "@/models/cb-notification"
import Loader from "@/components/collections/elements/Loader"
import { ToastNotificationTimeout } from "@/utils/helper-functions"

export default {
  mounted() {
      this.transitionName = "fade";
    },
    computed: {
      ...mapGetters([
        'hp_partially_loaded',
        'authType',
        'current_notification',
        'set_loader',
        'checkout_steps',
        'one_screen_checkout',
        'authenticated',
        "is_hp_from_plan"
      ]),
      headerType() {
        this.isNewHeader = false;
        this.currentHeader = this.$route.meta.headerType ? this.$route.meta.headerType(this.$route) : this.$route.meta.header;
        if(this.currentHeader != "header-thankyou" && this.prevHeader != this.currentHeader){
          if(document.getElementById("cb-header"))
            document.getElementById("cb-header").$prevHeight = document.getElementById("cb-header").clientHeight + "px";
          this.isNewHeader = true;
        }
        if(document.getElementById("cb-header")){
          document.getElementById("cb-header").$prevHeight = document.getElementById("cb-header").clientHeight + "px";
        }
        this.prevHeader = this.currentHeader;
        return this.currentHeader;
      },
      canAnimate() {
        return !(this.$route.path.match(/.*\/checkout\/.*/) || this.one_screen_checkout);
      },
      editMode() {
        return this.$route.query.mode == "edit";
      }
    },
    data() {
      return {
        transitionName: "",
        errMessage: "",
        showNotification: false,
        isNewHeader:false,
        prevHeader: "",
        currentheader: "",
        showLoader: false,
      }
    },
    watch: {
      set_loader(newValue, oldValue) {
        this.showLoader = newValue ? true : false;
      },
      current_notification(newValue, oldValue) {
        if(!newValue) {
          this.showNotification = false;
          return;
        }
        if(newValue.message) {
          this.showNotification = true;
          if(newValue.type == 'error') {
            window.clearTimeout(this.notificationTimeout);
            if(!newValue.isDismissible) {
              this.notificationTimeout = window.cbTimeout(() => this.showNotification = false, ToastNotificationTimeout);
            }
          }
        }
      },
      authenticated(newValue, oldValue) {
        if(!this.hp_partially_loaded) {
          return;
        }
        if (oldValue && !newValue) {
          if(this.authType == "email" && this.is_hp_from_plan) {
            this.$router.push({
              name: "check_user"
            });
          }
          else {
            this.$router.push({
              name: "error"
            });
          }
        }
      },
      hp_partially_loaded(newValue, oldValue) {
        if(newValue && !oldValue) {
          window.cbPostMessage("cb.loaded");
          document.getElementById("app").focus();
          window.cb_loaded = true;
          window.cbTimeout(() => document.getElementById("app").focus(), 1000);
        }
      }
    },
    created() {
      this.$store.dispatch('set_hp_token', this.$route.params.token);
      if(this.$route.params.token) {
      window.cbPostMessage({ 
        key: "cb.set_hp_token",
        value: this.$route.params.token,
        type: 'hp_token'
        });
      }
      logger.addMetaData("hp_token", this.$route.params.token);

      this.$store.dispatch('fetch_data', this.$route.params.token).catch(error => {
        // if(error.status == 404) {
        this.$store.dispatch('set_current_notification', new CBNotification('error', error));
        this.$router.push({name: 'error'});
        // }
        logger.e(error);
      });
    },
    beforeRouteEnter(to, from, next) {
      if(to.name != "cart_screen") {
        next({name: 'cart_screen', params: to.params, replace: true});
      }
      else {
        next();
      }
    },
    components: {
      "header-1": Type1,
      "header-2": Type2,
      "header-3": Type3,
      "header-thankyou": ThankYouHeader,
      "cb-modal": ModalBox,
      "cb-loader": Loader,
    },
}
</script>
